import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import OutsourcedJobLinkSearchParams from './OutsourcedJobLinkSearchParams';
import OutsourcedJobLinkService from '../../../Services/OutsourcedJobLinkService';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import OutsourcedJobLinkItem from '../../../Domain/OutsourcedJobLinkItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ChangeFieldworkOfficeWindowDescription from './ChangeFieldworkOfficeWindowDescription';
import ChangeFieldworkOfficeItem from '../../../Domain/ChangeFieldworkOfficeItem';
import OutsourcedStatusEnum from '../../../Enums/OutsourcedStatusEnum';
import AuthService from '../../../Services/authService';

class OutsourcedJobLinkAdmin extends React.Component {
  static defaultProps = {
    ClientId: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new OutsourcedJobLinkSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      allItemsInTheSearchSetAreSelected: false,
    };

    if (this.props.ClientId) {
      this.state.searchItem.ClientIds = [this.props.ClientId];
    }

    this.refresh = this.refresh.bind(this);
    this.startSearch = this.startSearch.bind(this);

    OutsourcedJobLinkItem.deleteFunction = this.deleteFunction.bind(this);
    OutsourcedJobLinkItem.markAsUninvoiceableFunction = this.markAsUninvoiceableFunction.bind(this);
    OutsourcedJobLinkItem.markAsInvoiceableFunction = this.markAsInvoiceableFunction.bind(this);
    OutsourcedJobLinkItem.changeFieldworkOfficeFunction = this.changeFieldworkOfficeForItem.bind(this);
    OutsourcedJobLinkItem.removeFeeFunction = this.removeFeeForItem.bind(this);
    OutsourcedJobLinkItem.fwApproveFunction = this.fwApproveForItem.bind(this);
    OutsourcedJobLinkItem.osApproveFunction = this.osApproveForItem.bind(this);
  }

  deleteFunction(id) {
    ErrorMessage.SetApprove('Are you sure you want to delete this Outsourced Job Link?', () =>
      this.deleteFunctionInner(id)
    );
  }

  deleteFunctionInner(id) {
    OutsourcedJobLinkService.Delete(id)
      .then(() => this.refresh())
      .catch((error) => ErrorMessage.SetErrorMessage('OJLA51', error));
  }

  markAsUninvoiceableFunction(id) {
    ErrorMessage.SetApprove('Are you sure you want to mark this Job Link as Uninvoiceable?', () =>
      this.markAsUninvoiceableFunctionInner(id)
    );
  }

  markAsUninvoiceableFunctionInner(id) {
    OutsourcedJobLinkService.MarkAsUninvoiceable(id)
      .then(() => this.refresh())
      .catch((error) => ErrorMessage.SetErrorMessage('OJLA57', error));
  }

  markAsInvoiceableFunction(id) {
    ErrorMessage.SetApprove('Are you sure you want to mark this Job Link as Invoiceable?', () =>
      this.markAsInvoiceableFunctionInner(id)
    );
  }

  markAsInvoiceableFunctionInner(id) {
    OutsourcedJobLinkService.MarkAsInvoiceable(id)
      .then(() => this.refresh())
      .catch((error) => ErrorMessage.SetErrorMessage('OJLA63', error));
  }

  collectJobLinks() {
    OutsourcedJobLinkService.CollectOutsourcedJobLinks()
      .then(() => {
        ErrorMessage.SetSuccess(
          'Job Link Collection process has been triggered. The process will run in the background and create the Job Links when completed.'
        );
        this.refresh();
      })
      .catch((error) => ErrorMessage.SetErrorMessage('OJLA74', error));
  }

  assignFees() {
    OutsourcedJobLinkService.AssignOutsourcedFees()
      .then(() => {
        ErrorMessage.SetSuccess(
          'Fee Attachment process has been triggered. The process will run in the background and update the Job Links when completed.'
        );
        this.refresh();
      })
      .catch((error) => ErrorMessage.SetErrorMessage('OJLA85', error));
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  changeFieldworkOfficeForItem(id) {
    const item = new ChangeFieldworkOfficeItem();
    item.OutsourcedJobLinkIds = [id];
    item.AllItemsSelected = false;
    item.SearchItem = null;
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  changeFieldworkOfficeForSelected() {
    const item = new ChangeFieldworkOfficeItem();
    item.OutsourcedJobLinkIds = this.state.allItemsInTheSearchSetAreSelected
      ? []
      : this.state.itemList.filter((x) => x.Selected === true).map((x) => x.OutsourcedJobLinkId);
    item.AllItemsSelected = this.state.allItemsInTheSearchSetAreSelected;
    item.SearchItem = this.state.allItemsInTheSearchSetAreSelected ? this.state.searchItem : null;
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  removeFeeForItem(id) {
    ErrorMessage.SetApprove('Are you sure you want to remove the fee from this Outsourced Job Link?', () =>
      this.removeFeeInner([id], false, null)
    );
  }

  removeFeeForSelected() {
    const count = this.getNumberOfSelectedElements();
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `Are you sure you want to remove the fee from all ${this.state.numberOfElementsInTheTable} items in the current list (according to the search parameters)?`
      : `Are you sure you want to remove the fee from the ${count} selected item(s)?`;

    const ids = this.state.allItemsInTheSearchSetAreSelected
      ? []
      : this.state.itemList.filter((x) => x.Selected === true).map((x) => x.OutsourcedJobLinkId);

    ErrorMessage.SetApprove(message, () =>
      this.removeFeeInner(ids, this.state.allItemsInTheSearchSetAreSelected, this.state.searchItem)
    );
  }

  removeFeeInner(ids, allItemsSelected, searchItem) {
    OutsourcedJobLinkService.RemoveFee(ids, allItemsSelected, allItemsSelected ? searchItem : null)
      .then(() => this.refresh())
      .catch((error) => ErrorMessage.SetErrorMessage('OJLA_RF', error));
  }

  fwApproveForItem(id) {
    ErrorMessage.SetApprove('Are you sure you want to approve this Outsourced Job Link as the Bill To Office?', () =>
      this.approveInner([id], false, null, OutsourcedStatusEnum.ReadyForInvoicing)
    );
  }

  osApproveForItem(id) {
    ErrorMessage.SetApprove(
      'Are you sure you want to approve this Outsourced Job Link as the Work Done By office?',
      () => this.approveInner([id], false, null, OutsourcedStatusEnum.ApprovedForInvoicing)
    );
  }

  fwApproveForSelected() {
    // Name which of the two approvals this is: both buttons used to raise the same "Approve the N selected
    // item(s)?" message, so the confirmation could not tell you which one you had pressed.
    const count = this.getNumberOfSelectedElements();
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `Are you sure you want to approve all ${this.state.numberOfElementsInTheTable} items in the current list as the Bill To Office?`
      : `Are you sure you want to approve the ${count} selected item(s) as the Bill To Office?`;
    const ids = this.state.allItemsInTheSearchSetAreSelected
      ? []
      : this.state.itemList.filter((x) => x.Selected === true).map((x) => x.OutsourcedJobLinkId);
    ErrorMessage.SetApprove(message, () =>
      this.approveInner(
        ids,
        this.state.allItemsInTheSearchSetAreSelected,
        this.state.searchItem,
        OutsourcedStatusEnum.ReadyForInvoicing
      )
    );
  }

  osApproveForSelected() {
    const count = this.getNumberOfSelectedElements();
    const message = this.state.allItemsInTheSearchSetAreSelected
      ? `Are you sure you want to approve all ${this.state.numberOfElementsInTheTable} items in the current list as the Work Done By office?`
      : `Are you sure you want to approve the ${count} selected item(s) as the Work Done By office?`;
    const ids = this.state.allItemsInTheSearchSetAreSelected
      ? []
      : this.state.itemList.filter((x) => x.Selected === true).map((x) => x.OutsourcedJobLinkId);
    ErrorMessage.SetApprove(message, () =>
      this.approveInner(
        ids,
        this.state.allItemsInTheSearchSetAreSelected,
        this.state.searchItem,
        OutsourcedStatusEnum.ApprovedForInvoicing
      )
    );
  }

  approveInner(ids, allItemsSelected, searchItem, newStatus) {
    OutsourcedJobLinkService.Approve(ids, allItemsSelected, allItemsSelected ? searchItem : null, newStatus)
      .then(() => this.refresh())
      .catch((error) => ErrorMessage.SetErrorMessage('OJLA_APR', error));
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem }, shownPanel: ShownPanelsEnum.None });
  }

  changeOfItemListFunction(itemList, numberOfElementsInTheTable) {
    this.setState({
      itemList,
      numberOfElementsInTheTable,
    });
  }

  startSearch(searchItem) {
    if (this.props.ClientId) {
      searchItem.ClientIds = [this.props.ClientId.toString()];
    }
    this.setState({
      searchItem: { ...searchItem },
    });
  }

  renderPanels() {
    return (
      <>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh()}
            windowDescription={ChangeFieldworkOfficeWindowDescription}
            errorCode='OJLA_CFO'
          />
        )}
      </>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <FigmaButtonRow
          className={this.props.ClientId ? 'InnerMenuButtonFigmaList' : 'MenuButtonList'}
          buttons={[
            {
              iconName: 'fa-solid fa-minimize',
              type: ButtonTypeEnum.NormalIconOnly,
              iconPosition: IconPositionEnum.Center,
              color: ButtonColorsEnum.Primary,
              onClick: () => this.collectJobLinks(),
              tooltip: 'Collect Job Links',
              roleKey: 'outsourced_joblinks_edit',
            },
            {
              iconName: 'fa-solid fa-link',
              type: ButtonTypeEnum.NormalIconOnly,
              iconPosition: IconPositionEnum.Center,
              color: ButtonColorsEnum.Common,
              onClick: () => this.assignFees(),
              tooltip: 'Assign Fees',
              roleKey: 'outsourced_joblinks_edit',
            },
            {
              iconName: 'fa-solid fa-building',
              type: ButtonTypeEnum.NormalIconOnly,
              iconPosition: IconPositionEnum.Center,
              color: ButtonColorsEnum.Common,
              onClick: () => this.changeFieldworkOfficeForSelected(),
              tooltip: 'Change Bill To Office',
              roleKey: 'outsourced_joblinks_edit',
              disabled:
                this.getNumberOfSelectedElements() === 0 ||
                this.state.itemList.some(
                  (x) =>
                    x.Selected &&
                    x.Status !== OutsourcedStatusEnum.Collected &&
                    x.Status !== OutsourcedStatusEnum.FeeAttached
                ),
            },
            {
              iconName: 'fa-solid fa-unlink',
              type: ButtonTypeEnum.NormalIconOnly,
              iconPosition: IconPositionEnum.Center,
              color: ButtonColorsEnum.Common,
              onClick: () => this.removeFeeForSelected(),
              tooltip: 'Remove Fee',
              roleKey: 'outsourced_joblinks_edit',
              disabled:
                this.getNumberOfSelectedElements() === 0 ||
                this.state.itemList.some((x) => x.Selected && x.Status !== OutsourcedStatusEnum.FeeAttached),
            },
            {
              iconName: 'fa-solid fa-check',
              type: ButtonTypeEnum.NormalIconOnly,
              iconPosition: IconPositionEnum.Center,
              color: ButtonColorsEnum.Common,
              onClick: () => this.fwApproveForSelected(),
              tooltip: 'Approve (Bill To Office)',
              roleKey: 'outsourced_joblinks_edit',
              disabled:
                this.getNumberOfSelectedElements() === 0 ||
                this.state.itemList.some((x) => x.Selected && x.Status !== OutsourcedStatusEnum.FeeAttached) ||
                this.state.itemList.some(
                  (x) => x.Selected && x.FieldworkOfficeId !== AuthService.getInstance().GetLoggedInUser()?.officeId
                ),
            },
            {
              iconName: 'fa-solid fa-check-double',
              type: ButtonTypeEnum.NormalIconOnly,
              iconPosition: IconPositionEnum.Center,
              color: ButtonColorsEnum.Common,
              onClick: () => this.osApproveForSelected(),
              tooltip: 'Approve (Work Done By)',
              roleKey: 'outsourced_joblinks_edit',
              disabled:
                this.getNumberOfSelectedElements() === 0 ||
                this.state.itemList.some((x) => x.Selected && x.Status !== OutsourcedStatusEnum.ReadyForInvoicing) ||
                this.state.itemList.some(
                  (x) => x.Selected && x.OutsourcingOfficeId !== AuthService.getInstance().GetLoggedInUser()?.officeId
                ),
            },
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={OutsourcedJobLinkItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={OutsourcedJobLinkService.GetList}
          convertDBItemsFunction={OutsourcedJobLinkService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={OutsourcedJobLinkSearchParams}
          orderBy={'OutsourcedJobLinkId'}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction.bind(this)}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) =>
            this.setState({ allItemsInTheSearchSetAreSelected })
          }
          errorCode='OJL65'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search for id, user, client or third party job id...'
        />
      </div>
    );
  }
}

export default OutsourcedJobLinkAdmin;
